import { SiteActivityEvent, generator } from '@cms-max/cms-browser-api-client'
import { GeneratorArgs } from './generateEventMap'
import { Activity, Component } from '@cms-max/medicare-api-sdk'

export const connectedAppsGenerator = generator(({ i18n }: GeneratorArgs) => {
  const ns = 'connectedApps'

  const createConnectedAppsLinkClickHandler = (
    elementId: string
  ) => (params: {
    linkText?: string,
    linkUrl?: string
  }): SiteActivityEvent => ({
    core: {
      elementId,
      property: 'MAX',
      activity: Activity.LinkClick,
      component: Component.AccountSettings,
      coreClickData: {
        linkText: params.linkText,
        linkUrl: params.linkUrl
      }
    }
  })

  return {
    accountsettings_connectedappsbacktoaccountsettings_click: createConnectedAppsLinkClickHandler(
      'accountsettings_connectedappsbacktoaccountsettings_click'
    ),
    accountsettings_connectedappsbrowseapps_click: createConnectedAppsLinkClickHandler(
      'accountsettings_connectedappsbrowseapps_click'
    ),
    accountsettings_connectedappsprivacy_click: createConnectedAppsLinkClickHandler(
      'accountsettings_connectedappsprivacy_click'
    ),
    accountsettings_connectedappstermsofservice_click: createConnectedAppsLinkClickHandler(
      'accountsettings_connectedappstermsofservice_click'
    ),
    accountsettings_connectedappsstopsharing_click: (params: { appName: string }) => ({
      core: {
        elementId: 'accountsettings_connectedappsstopsharing_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        coreClickData: {
          linkText: i18n.t(
            'stopSharingButton.ariaLabel',
            { appName: params.appName, ns }
          )
        }
      }
    }),
    accountsettings_connectedappsstopsharingdecline_click: {
      core: {
        elementId: 'accountsettings_connectedappsstopsharingdecline_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings
      }
    },
    accountsettings_connectedappsstopsharingconfirm_click: {
      core: {
        elementId: 'accountsettings_connectedappsstopsharingconfirm_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        coreClickData: {
          linkText: i18n.t('stopModal.buttons.confirm.label', { ns })
        }
      }
    },
    accountsettings_connectedappsstopsharingsuccessclose_click: {
      core: {
        elementId: 'accountsettings_connectedappsstopsharingsuccessclose_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings
      }
    },
    accountsettings_connectedappsstopsharingerrorclose_click: {
      core: {
        elementId: 'accountsettings_connectedappsstopsharingerrorclose_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings
      }
    }
  }
})

export type ConnectedAppsKeys = keyof ReturnType<
  typeof connectedAppsGenerator
>

export default connectedAppsGenerator
